<template>
  <div
    :key="appKey"
    id="app"
    :style="{
      '--font': font,
      '--main-color': colors.mainColor,
      '--secondary-color': colors.secondaryColor,
      '--text-color': colors.textColor,
      '--header-color': '#8f8d8e',
      '--background-color': '#1d1f1f',
      '--separator-color': '#2b2b2b',
      '--button-background': button.bgColor,
      '--button-outline': button.outlineColor,
      '--button-hover': button.hoverColor,
      '--button-text': button.textColor,
      '--input-text': input.textColor,
      '--input-bg': input.bgColor,
      '--input-border': input.borderColor,
      '--input-panelBorderColor': input.panelBorderColor,
      '--input-borderRadius': input.borderRadius,
      '--scrollbar-bgColor': scrollbar.bgColor,
      '--scrollbar-handleColor': scrollbar.handleColor,
      '--scrollbar-borderRadius': scrollbar.borderRadius,
      '--headerLogo-position': accessConfig.headerLogoPosition,
      '--login-bg': accessConfig.loginView.bg,
      '--login-bg1': accessConfig.loginView.bg1,
      '--login-bg2': accessConfig.loginView.bg2,
      '--feedSocial-bgColor': feedSocial.postColor,
      '--feedSocial-borderRadius': feedSocial.borderRadius,
      '--feedSocial-subColor': feedSocial.subColor,
      '--feedSocial-textColor': feedSocial.textColor,
      '--feedSocial-postButtonBgColor': feedSocial.postButtonBgColor,
      '--feedSocial-postButtonTextColor': feedSocial.postButtonTextColor,
      '--feedSocial-postInputOutlineColor': feedSocial.postInputOutlineColor,
      '--live-bgColor': live.bgColor,
      '--live-itemColor': live.itemColor,
      '--live-textColor': live.textColor,
      '--live-borderRadius': live.borderRadius,
      '--live-borderColor': live.borderColor,
      '--userProfile-topBgColor': userProfile.topBgColor,
      '--userProfile-buttonBgColor': userProfile.buttonBgColor,
      '--userProfile-textColor': userProfile.textColor,
      '--userProfile-buttonTextColor': userProfile.buttonTextColor,
      '--userProfile-middleBgColor': userProfile.middleBgColor,
      '--userProfile-bottomBgColor': userProfile.bottomBgColor,
      '--userProfile-textFontSize': userProfile.textFontSize,
      '--userProfile-borderRadius': userProfile.borderRadius,
      '--chat-headerColor': chat.headerColor,
      '--chat-mainColor': chat.mainColor,
      '--chat-bgColor': chat.bgColor,
      '--chat-pinnedBGColor': chat.pinnedBGColor,
      '--chat-pinnedNameColor': chat.pinnedNameColor,
      '--chat-pinnedTextColor': chat.pinnedTextColor,
      '--chat-outlineColor': chat.outlineColor,
      '--chat-nameColor': chat.nameColor,
      '--chat-adminNameColor': chat.adminNameColor,
      '--chat-adminBoxColor': chat.adminBoxColor,
      '--chat-nameBoxColor': chat.nameBoxColor,
      '--chat-boxColor': chat.boxColor,
      '--chat-textColor': chat.textColor,
      '--chat-inputTextColor': chat.inputTextColor,
      '--chat-inputBGColor': chat.inputBGColor,
      '--chat-inputOutlineColor': chat.inputOutlineColor,
      '--chat-sendTextColor': chat.sendTextColor,
      '--chat-sendBGColor': chat.sendBGColor,
      '--chat-sendOutlineColor': chat.sendOutlineColor,
      '--chat-messagesOutlineColor': chat.messagesOutlineColor,
      '--chat-scrollbarBGColor': chat.scrollbarBGColor,
      '--chat-scrollbarHandleColor': chat.scrollbarHandleColor,
      '--chat-borderRadius': chat.borderRadius,
      '--chat-editBtnColor': chat.editBtnColor,
      '--chat-editBtnBGColor': chat.editBtnBGColor,
    }">
    <JitsiMeeting ref="jitsiMeeting" :roomID="jitsiRoomID" :roomName="jitsiRoomName" @videoConferenceLeft="deleteTakenMetaPosition" v-if="showJitsiMeeting && jitsiRoomID" />

    <transition appear name="fade" mode="in-out">
      <router-view :key="$route.fullPath" />
    </transition>

    <NetworkWidget v-if="showNetworkWidget" />

    <modals-container name="modals-container" />
    <v-dialog :clickToClose="false" />

    <!-- <Notifications /> -->

    <Notes @close="showNotes = false" v-if="showNotes" />

    <UserSupportBox v-if="useSupportBox" />
  </div>
</template>

<script>
import NetworkWidget from '@/components/general/NetworkWidget.vue';
import JitsiMeeting from '@/components/webrtc/JitsiMeeting.vue';
import Notes from '@/components/Notes/Notes.vue';
import api from '@/services/api.js';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';
import UserSupportBox from '@/components/general/UserSupportBox.vue';
import Notifications from '@/components/general/Notifications.vue';

// !!! UNICO SDK !!!
// import {
//   UnicoThemeBuilder,
//   UnicoCheckBuilder,
//   SelfieCameraTypes,
//   DocumentCameraTypes,
// } from "unico-webframe";

export default {
  name: 'App',

  components: { NetworkWidget, JitsiMeeting, Notes, Sidebox, UserSupportBox, Notifications },

  data() {
    return {
      favicon: null,
      colors: null,
      button: null,
      input: null,
      scrollbar: null,
      accessConfig: null,
      profileConfig: null,
      chat: null,
      userProfile: null,
      font: 'Lato',
      feedSocial: null,
      appKey: 0,
      headerRoutes: [],
      started: false,
      sessionActionInterval: null,
      sessionActionIntervalInMiliseconds: 90000,
      sessionCheckInterval: null,
      metaActivityID: null,
      showJitsiMeeting: false,
      jitsiRoomID: null,
      jitsiRoomName: null,
      currentMetaID: null,
      currentJitsiRoomName: 'default',
      showNotes: false,
      unicoCheckSDK: {
        builder: null,
        theme: null,
        camera: null,
        services: '/data/services.json',
        models: '/data/models',
        resources: '/data/resources',
        openerData: null,
      },
    };
  },
  watch: {
    $route() {
      clearInterval(this.sessionActionInterval);
      clearInterval(this.sessionCheckInterval);

      if (this.$store.state.user.token && this.$store.state.user.id) {
        this.informSessionAction();
        this.sessionActionInterval = setInterval(() => {
          this.informSessionAction();
        }, this.sessionActionIntervalInMiliseconds);

        if (this.$store.state.template.accessConfig.allowAnonimous !== true) {
          this.informSessionCheck();
          this.sessionCheckInterval = setInterval(() => {
            this.informSessionCheck();
          }, this.sessionActionIntervalInMiliseconds);
        }
      }

      if (this.accessConfig.usePrecache) {
        this.$nextTick(() => {
          if (this.$route.name !== 'Home' && this.$route.name !== 'Login' && this.$route.name !== 'Register') {
            if (!this.started) this.openRoutes();
          }
        });
      }

      // RECAPTCHA BADGE VISIBILITY
      this.$nextTick(() => {
        const recaptchaBadge = document.querySelector('.grecaptcha-badge');

        // HIDE GOOGLE RECAPTCHA
        if (this.$store.state.template.showRecaptcha) {
          if (this.$route.name === 'Home' || this.$route.name === 'Login' || this.$route.name === 'Register') {
            recaptchaBadge.style.visibility = 'visible';
          } else {
            recaptchaBadge.style.visibility = 'hidden';
          }
        } else {
          recaptchaBadge.style.visibility = 'hidden !important';
        }
      });
    },
  },
  computed: {
    useSupportBox() {
      if (this.$store.state.user.id && this.$store.state.template.userProfile && this.$store.state.template.userProfile.supportChatProvider && this.$store.state.template.userProfile.supportChatProvider.active === true) return true;
      else return false;
    },
    showNetworkWidget() {
      const condition =
        (this.$route.path !== '/' &&
          this.$route.name !== 'LandingPage' &&
          this.$route.name !== 'Home' &&
          this.$route.name !== 'Login' &&
          this.$route.name !== 'Register' &&
          this.$store.state.template.userProfile.contactsProvider.name == 'Network' &&
          this.$store.state.template.talkChannel &&
          this.$route.name !== 'Timeline' &&
          this.$route.name !== 'PhotoBooth') ||
        this.timeLineCondition;
      return this.userHasToken && this.isTalkChannel && condition;
    },
    timeLineCondition() {
      return window.innerWidth > 706 && this.$route.name === 'Timeline';
    },
    userHasToken() {
      return this.$store.state.user && this.$store.state.user.token;
    },
    isTalkChannel() {
      return this.$store.state.template.header.loginVisible && this.$store.state.template.talkChannel;
    },
    myUserID() {
      return this.$store.state.user.id;
    },
  },
  methods: {
    handleIcon() {
      // accessing the link tag
      const favicon = document.getElementById('favicon');
      if (this.favicon) favicon.href = this.favicon;
    },
    openRoutes() {
      if (!this.$store.state.user.id) return;
      api
        .get(`event/${this.$store.state.eventId}/menu`)
        .then((response) => {
          this.headerRoutes = response.data;
          // console.log('headerRoutes lenght: ' + this.headerRoutes.length);
          this.headerRoutes.map((menuItem) => {
            menuItem.link = JSON.parse(menuItem.link);
            if (menuItem.link === null) menuItem.link = 'submenu';
            if (menuItem.submenu) {
              menuItem.submenu.map((submenuItem) => {
                submenuItem.link = JSON.parse(submenuItem.link);
                return submenuItem;
              });
            }
            return menuItem;
          });
          this.$root.$emit('startCaching');
          this.started = true;
          const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
          (async () => {
            for (let index = 0; index < this.headerRoutes.length; ++index) {
              // Wait to do this one until a delay after the last one
              if (index > 0) {
                await delay(1300); // 5000 for five seconds
                if (index === this.headerRoutes.length - 1) {
                  this.$router.replace(this.headerRoutes[0].link);
                  setTimeout(() => {
                    this.$root.$emit('routesCached', 'all set');
                  }, 1000);
                } else {
                  this.$router.replace(this.headerRoutes[index].link);
                }
              }
            }
          })();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    deleteTakenMetaPosition() {
      // console.log("deleteTakenMetaPosition actID, metaID: ", this.metaActivityID, this.currentMetaID);
      if (!this.metaActivityID || !this.currentMetaID) return;
      api
        .delete(`event/${this.$store.state.eventId}/activity/${this.metaActivityID}/meta/${this.currentMetaID}`)
        .then((response) => {
          this.showJitsiMeeting = false;
          this.$root.$emit('closeMetaModal');
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // UNICOCHECK SDK BUILDER
    instantiateTheme() {
      try {
        this.unicoCheckSDK.theme = new UnicoThemeBuilder()
          .setColorSilhouetteSuccess('#0384fc')
          .setColorSilhouetteError('#D50000')
          .setColorSilhouetteNeutral('#fcfcfc')
          .setBackgroundColor('#f9f9f9')
          .setColorText('#0384fc')
          .setBackgroundColorComponents('#0384fc')
          .setColorTextComponents('#dff1f5')
          .setBackgroundColorButtons('#0384fc')
          .setColorTextButtons('#dff1f5')
          .setBackgroundColorBoxMessage('#fff')
          .setColorTextBoxMessage('#000')
          .setHtmlPopupLoading('<div style="position:absolute;top:45%;right:50%;transform:translate(50%,-50%);z-index:10;text-align:center;">Carregando...</div>')
          .build();
      } catch (err) {
        console.error(err);
      }
    },
    async instantiateCamera() {
      try {
        await this.unicoCheckSDK.builder.setTheme(this.unicoCheckSDK.theme).setModelsPath(this.unicoCheckSDK.models).setResourceDirectory(this.unicoCheckSDK.resources);

        this.unicoCheckSDK.camera = await this.unicoCheckSDK.builder.build();
      } catch (err) {
        console.error(err);
      }
    },
    instantiateNewBuilder() {
      try {
        this.unicoCheckSDK.builder = new UnicoCheckBuilder();
      } catch (err) {
        console.error(err);
      }
    },
    async buildUnicoCheckSDK() {
      await Promise.all([this.instantiateNewBuilder(), this.instantiateTheme()])
        .then(async () => {
          await this.instantiateCamera();
        })
        .then(async () => {
          //console.log('loaded SDK, preparing selfie camera', this.unicoCheckSDK.services);
          this.$store.commit('buildUnicoCheckSDK', this.unicoCheckSDK);
        })
        .catch((err) => console.error(err));
    },
    informSessionCheck() {
      let payload = {
        session_id: this.$store.state.user.token,
        token: this.$store.state.user.token,
      };
      api
        .post(`event/${this.$store.state.eventId}/sessionCheck`, payload)
        .then((response) => {
          if (!response.data) return;
          const data = response.data;
          if ((data.event_user_role_id && this.$store.state.user.role != data.event_user_role_id) || (data.level >= 0 && this.$store.state.user.level != data.level)) {
            this.$store.commit({
              type: 'setUserRole',
              role: data.event_user_role_id,
              level: data.level,
            });
            if (this.$route.name == 'FoyerLevels') this.$emit('userStateChanged');
          }
        })
        .catch((err) => console.error(err));
    },
    informSessionAction() {
      api.post(`sessionAction/`, {
        action: 'Check Incomming',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
  },
  beforeCreate() {
    this.$store.commit('initializeStore');
  },
  beforeMount() {
    //console.log('App before mount')
    try {
      document.title = this.$store.state.template.title;
      this.favicon = this.$store.state.template.favicon;
      this.colors = this.$store.state.template.colors;
      this.button = this.$store.state.template.button;
      this.input = this.$store.state.template.input;
      this.scrollbar = this.$store.state.template.scrollbar;
      this.accessConfig = this.$store.state.template.accessConfig;
      this.profileConfig = this.$store.state.template.profileConfig;
      this.feedSocial = this.$store.state.template.feedSocial;
      this.live = this.$store.state.template.live;
      this.chat = this.$store.state.template.chat;
      this.userProfile = this.$store.state.template.userProfile;

      // normalize font string to default font
      if (this.$store.state.template.font !== '') {
        // console.log('font: ' + this.$store.state.template.font);
        this.font = this.$store.state.template.font;
      } else this.font = 'Lato';
    } catch (err) {
      console.log('err on mount app', err);
    }
    //console.log('app mounting');

    function detectBrowserLanguage() {
      const searchParams = new URLSearchParams(window.location.search);
      const lang = searchParams.get('language-code');
      const supportedLanguages = ['pt', 'en', 'es', 'it', 'de', 'fr'];
      if (lang && supportedLanguages.includes(lang)) {
        return lang;
      }

      // Pega o idioma do navegador (ex: 'pt-BR', 'en-US', 'es-ES')
      const browserLang = navigator.language || navigator.userLanguage;

      // Extrai apenas o código do idioma (ex: 'pt', 'en', 'es')
      const langCode = browserLang.split('-')[0];

      // Verifica se o idioma detectado existe nas suas traduções

      //console.log('langCode=', langCode);
      if (supportedLanguages.includes(langCode)) {
        return langCode;
      }

      // Se não suportar o idioma, retorna português como padrão
      return 'pt';
    }
    try {
      this.$store.state.user.language = detectBrowserLanguage();
      //console.log('lang=', this.$store.state.user.language);
    } catch (err) {
      console.log(err);
    }
  },
  mounted() {
    this.handleIcon();
    // Precache loading panel bg image
    if (this.accessConfig.usePrecache) {
      const image = new Image();
      image.src = 'https://aws-manhattan-bucket-01.s3.amazonaws.com/event/4358c130-d1b4-11ea-b523-b9262ae27927/60a509b96f670e3fbd83b4c60ce15060-hero.jpg';
    }
    // UPDATE SESSION ACTION INTERVAL
    if (Number.isSafeInteger(this.accessConfig.sessionActionIntervalInMiliseconds) && this.accessConfig.sessionActionIntervalInMiliseconds > this.sessionActionIntervalInMiliseconds) {
      sessionActionIntervalInMiliseconds = this.accessConfig.sessionActionIntervalInMiliseconds;
    }

    // JITSI LISTENER
    this.$root.$on('openJitsi', (data) => {
      this.showJitsiMeeting = true;
      this.jitsiRoomID = data.roomID;
      this.jitsiRoomName = data.roomName;
      this.metaActivityID = data.metaActivityID;
      this.currentMetaID = data.metaID;
    });
    this.$root.$on('leaveJitsiRoom', () => {
      this.$refs.jitsiMeeting.hangup();
      this.deleteTakenMetaPosition();
      this.showJitsiMeeting = false;
    });

    // USER NOTES LISTENER
    this.$root.$on('openUserNotes', () => {
      this.showNotes = true;
    });

    // UNICOCHECK SDK BUILDER
    if (this.accessConfig.useSimulatedUnicoTransaction) {
      this.buildUnicoCheckSDK();
    }

    // SESSION ACTION AND CHECK INTERVALS
    clearInterval(this.sessionActionInterval);
    clearInterval(this.sessionCheckInterval);

    if (this.$store.state.user.token && this.$store.state.user.id) {
      //console.log('State', this.$store.state)
      this.informSessionAction();
      this.sessionActionInterval = setInterval(() => {
        this.informSessionAction();
      }, this.sessionActionIntervalInMiliseconds);

      if (this.$store.state.template.accessConfig.allowAnonimous !== true) {
        this.informSessionCheck();
        this.sessionCheckInterval = setInterval(() => {
          this.informSessionCheck();
        }, this.sessionActionIntervalInMiliseconds);
      }
    }
    //console.log('Mounted');
  },

  beforeDestroy() {
    clearInterval(this.sessionActionInterval);
    clearInterval(this.sessionCheckInterval);
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

:root {
  font-size: 16px;
}

html {
  height: 100%;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  -webkit-tap-highlight-color: transparent;
  // background-color: var(--main-color, black) !important;
  background: transparent;
}

body {
  font-weight: 300;
  padding: 0;
  margin: 0;
  min-height: 100%;
}

a {
  text-decoration: none;
  color: var(--text-color, #fff);
}

@import url('https://fonts.googleapis.com/css2?family=Lato');
@import url('https://fonts.googleapis.com/css2?family=Roboto');
@import url('https://fonts.googleapis.com/css2?family=Comfortaa');
@import url('https://fonts.googleapis.com/css2?family=Poppins');

#app {
  font-family: var(--font), 'Lato', 'Arial', sans-serif;
  // font-family: 'Cavalier', sans-serif;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color, #fff);
  background-color: var(--main-color) !important;

  //min-width: 960px;
  min-height: 100dvh;
  overflow-x: hidden;
}

// // SCROLLBAR STYLE
::-webkit-scrollbar {
  // display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-track {
  background-color: rgb(70, 69, 66);
  // border-radius: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(102, 102, 102) !important;
  border-radius: 4px;
  background-image: none !important;
}
.vm--overlay {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.dialog-content,
.vue-dialog-button {
  color: #000 !important;
}

// ZENDESK
#launcher {
  transform: scale(0.8);
}

// ANIMATIONS - TRANSITIONS
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in;
}
.fade-enter,
.fade-leave-to {
  filter: blur(10px);
  // transform: scale(1.01);
}

.fade-fast-enter-active,
.fade-fast-leave-active {
  transition: all 0.1s ease-in;
}
.fade-fast-enter,
.fade-fast-leave-to {
  filter: blur(4px);
  // transform: scale(1.01);
}
.translate-down-enter-active,
.translate-down-leave-active {
  transition: all 0.1s ease-in-out;
  transform: translateY(-100%);
}
// .translate-down-enter,
// .translate-down-leave-to {
//   // transform: translateY(0);
//   // transform: scale(1);
// }
.pop-enter-active,
.pop-leave-active {
  transition: all 0.1s ease-in-out;
}
.pop-enter,
.pop-leave-to {
  transform: scale(0);
}

.opacity-enter-active,
.opacity-leave-active {
  transition: opacity 2.5s;
}
.opacity.enter,
.opacity-leave-to {
  opacity: 0.1;
}

.translate-enter-active {
  transition: all 0.8s ease-in-out;
}
.translate-leave-active {
  transition: all 0.8s ease-in-out;
}
.translate-enter,
.translate-leave-to {
  transform: translateY(-100px);
}

.qna-bounce-enter-active {
  animation: bounce-in 0.4s;
}
.qna-bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.95);
  }
}

.chat-translate-enter-active {
  animation: translate-in 0.5s;
}
@keyframes translate-in {
  from {
    transform: translateX(350px);
  }
  to {
    transform: translateX(0px);
  }
}

.translate-up-enter-active {
  transition: all 0.5s ease-in-out;
}
.translate-up-enter {
  transform: translateY(100px);
}
.translate-right-enter-active {
  transition: all 0.5s ease-in-out;
}
.translate-right-enter {
  transform: translateX(-200px);
}
.translate-left-enter-active {
  transition: all 0.5s ease-in-out;
}
.translate-left-enter {
  transform: translateX(200px);
}

.vm--container {
  z-index: 100000000 !important;
}

.vm--overlay {
  z-index: 1100;
}

.vue-dialog {
  color: #000;
  text-align: center;
  z-index: 1100;
}

// VueDragResize
.vdr {
  border: none !important;
}
.vdr.active:before {
  outline: none !important;
}
.vdr-stick {
  border: none !important;
  box-shadow: none !important;
  z-index: 10000 !important;
  background: transparent !important;
  pointer-events: auto !important;
}

.vdr-stick-ml,
.vdr-stick-mr {
  margin: 0 0 0 0 !important;
  transform: translateY(-50%);
  height: 145% !important;
}

.vdr-stick-tl,
.vdr-stick-bl,
.vdr-stick-tr,
.vdr-stick-br {
  width: 14px !important;
  height: 14px !important;
}

.vdr-stick-tm,
.vdr-stick-bm {
  margin: 0 0 0 -48% !important;
  width: 96% !important;
}

// DRAGRESIZE OUTLINE
.vdr.active:before {
  outline: none !important;
}
</style>
